const { sample } = require('lodash-es');
/**
 * Init a new random table and display an random element on click
 * @param {object} table HTML element
 * @returns {object} RandomTable object
 */
module.exports = function (table) {
  const items = [...table.querySelectorAll('.__item')];

  const instance = {
    items,
    currentItem: null,
    pickRandom() {
      const selected = sample(this.items);
      if (this.currentItem) {
        this.currentItem.classList.remove('js-__selected');
      }
      selected.classList.add('js-__selected');
      this.currentItem = selected;
    },
  };

  table.classList.add('js-__enabled');
  table.onclick = instance.pickRandom.bind(instance);
  instance.pickRandom();
  return instance;
};
